import type { ComponentProps } from 'react';

const LogoutOutlined = ({ fill, ...props }: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.7246 12.4131C22.0918 12.046 22.0918 11.4523 21.7246 11.0891L16.7251 6.08564C16.358 5.71848 15.7643 5.71848 15.401 6.08564C15.0378 6.45279 15.0339 7.04648 15.401 7.40973L18.7991 10.8078L9.1868 10.8117C8.66732 10.8117 8.24939 11.2297 8.24939 11.7491C8.24939 12.2686 8.66732 12.6866 9.1868 12.6866H18.7991L15.401 16.0847C15.0339 16.4518 15.0339 17.0455 15.401 17.4088C15.7682 17.772 16.3619 17.7759 16.7251 17.4088L21.7246 12.4131ZM8.56186 4.87482C9.08134 4.87482 9.49927 4.45689 9.49927 3.93741C9.49927 3.41793 9.08134 3 8.56186 3H5.43716C3.53891 3 2 4.53891 2 6.43716V17.0611C2 18.9594 3.53891 20.4983 5.43716 20.4983H8.56186C9.08134 20.4983 9.49927 20.0804 9.49927 19.5609C9.49927 19.0414 9.08134 18.6235 8.56186 18.6235H5.43716C4.57397 18.6235 3.87482 17.9243 3.87482 17.0611V6.43716C3.87482 5.57397 4.57397 4.87482 5.43716 4.87482H8.56186Z"
        fill={fill ?? '#E06358'}
      />
    </svg>
  );
};

export default LogoutOutlined;
